import React from 'react';
import PropTypes from 'prop-types';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import AccordionToggle from '../../AccordionToggle';
import PageSectionHeading from '../../PageSectionHeading';
import { colors } from '../../../styles';

const styles = css`
  padding: 45px 0;
  @media (min-width: 992px) {
    padding: 90px 0;
  }
  .AccordionSection_title {
    border-bottom: 1px solid ${colors.neutralDarker};
    padding: 20px;
    font-weight: 700;
    margin: 20px 0 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media (min-width: 992px) {
      font-size: 21px;
    }
  }
  .AccordionToggle_button:focus .AccordionSection_title {
    background-color: ${colors.neutral};
  }
  .AccordionToggle_button:hover .AccordionSection_title {
    background-color: ${colors.neutral};
  }
  .AccordionSection_arrow {
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid ${colors.brand3};
    margin: 0 0 0 45px;
  }
  .AccordionSection_collapsed-open .AccordionSection_arrow {
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid ${colors.brand3};
    border-top: none;
  }
  .AccordionSection_body {
    padding: 30px 40px 10px 40px;
    border: 2px solid ${colors.neutral};
    border-top: 0;
  }
  .AccordionSection_noContent p {
    font-size: 21px;
    text-align: center;
  }
`;

function PageAccordionSection({ content }) {
  return (
    <div className={styles}>
      {
        get(content, '[0].section_heading') &&
        <PageSectionHeading h3={get(content, '[0].section_heading')} underdog />
      }
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10 mx-lg-auto">
            {
              get(content, '[0].accordion_section_content').length > 0 &&
              <div>
                {get(content, '[0].accordion_section_content', []).map(item => (
                  <AccordionToggle
                    key={item._id}
                    button={({ contentVisible }) => (
                      <div className={`AccordionSection_title AccordionSection_collapsed ${contentVisible && 'AccordionSection_collapsed-open'}`}>
                        <div>
                          {item.accordion_title}
                        </div>
                        <div className="AccordionSection_arrow" />
                      </div>
                    )}
                  >
                    <div className="AccordionSection_body" dangerouslySetInnerHTML={SanitizeHtml(item.accordion_body)} />
                  </AccordionToggle>
                ),
                )}
              </div>
            }
            {
              get(content, '[0].accordion_section_content').length === 0 &&
              <div className="AccordionSection_noContent" dangerouslySetInnerHTML={SanitizeHtml(get(content, '[0].no_content_message'))} />
            }
          </div>
        </div>
      </div>
    </div>
  );
}

PageAccordionSection.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

PageAccordionSection.defaultProps = {
};

export default PageAccordionSection;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/PageAccordionSection.section.js